import { useEffect, useState } from "react";
import { Col, Row, Divider } from "antd";
import ProgrammeCard from "../cards/ProgrammeCard";
import {ParagraphHeader} from "@seims/shared";
import { programmes } from "../../utils/apiConstants";
import { isAuthorizedRole } from "../../security/AppSecurity";
import { RenderAuthenticated, RenderAnonymous } from "../../security/ToggleViews";

export default function MyProgrammeView() {

    const [subscribedInitiatives, SetSubscribedInitiatives] = useState([]);
    const [subscribedOffset, SetSubscribedOffset] = useState(0);

    const [unSubscribedInitiatives, SetUnSubscribedInitiatives] = useState([]);
    const [unSubscribedOffset, SetUnSubscribedOffset] = useState(0);
    const [screenWidth, SetScreenWidth] = useState(window.innerWidth);


    useEffect(() => {
        const _sub = getCardCount(true);
        SetSubscribedOffset(calculateGridOffset(_sub))

        const unsub = getCardCount(false);
        SetUnSubscribedOffset(calculateGridOffset(unsub));

        window.addEventListener('resize', () => {
            SetScreenWidth(window.innerWidth);
          })
        }, [window]);

    const getCardCount = (myInitiatives) => {
        let initivativeCount = 0;
        if (myInitiatives){
            const subs = programmes.filter((item) => isAuthorizedRole([item?.role]));
            SetSubscribedInitiatives(subs);
            initivativeCount = subs.length;
        } else {
            const unsubs = programmes.filter((item) => !isAuthorizedRole([item?.role]));
            SetUnSubscribedInitiatives(unsubs);
            initivativeCount = unsubs.length;
        }

        console.log("My initiatives: ", myInitiatives, initivativeCount)
        return initivativeCount;
    }

    const calculateGridOffset = (cardCount) => {
        let gridSpan = 24;
        if (screenWidth >= 992) { // lg breakpoint
            gridSpan = 6;
        } else if (screenWidth >= 768) { // md breakpoint
            gridSpan = 8;
        } else if (screenWidth >= 576) { // sm breakpoint
            gridSpan = 12;
        }
        console.log('gridspan ', gridSpan);
        const offset = Math.abs((24 - gridSpan*cardCount)/2);
        console.log('screen: ' + screenWidth, ' offset ' + offset, ' gridSpan ' + gridSpan, ' cardCount ' + cardCount);

        return offset;
    }

    return (
        <div>
            {/* <Row style={{ paddingBottom: 30, paddingTop: 10 }}>
                <Col xs={24}>
                    <ParagraphHeader header="SEIMS Initiatives" />
                </Col>
            </Row> */}

            {/* <Row style={{ paddingTop: 10 }}>
                
                <Col xs={24}>
                    <ParagraphHeader header="My Initiatives" />
                    <RenderAnonymous >
                        <div className="nys-info-bar my-initiatives-page">
                            <p>
                                <span>
                                    Please Note:
                                </span>
                                You are not logged in. Please log in to access the SEIMS Initiatives that you are subscribed to.
                            </p>
                        </div>
                    </RenderAnonymous>
                    <Row gutter={[16, 16]} className="card-section">
                        {subscribedInitiatives?.map((item, index) => (
                            <Col key={"Programme-" + index} className="my-initiatives" offset={index ===0? subscribedOffset: 0} xs={{ span: 24 }} sm={{ span: 12 }} md={8} lg={6}>
                                <ProgrammeCard programme={item} />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
           
            <Row style={{ paddingBottom: 30, paddingTop: 20 }} className="page-header">
                <Col xs={24}>
                    <ParagraphHeader header="Other Initiatives" />
                    <Row gutter={[16, 16]} className="card-section">
                        {unSubscribedInitiatives?.map((item, index) => (
                            <Col key={"Programme-" + index} className="my-initiatives" offset={index === 0 ? unSubscribedOffset : 0} xs={{ span: 24 }} sm={{ span: 12 }} md={8} lg={6}>
                                <ProgrammeCard programme={item} />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row> */}


<Row style={{ paddingTop: 10 }}>
                
                <Col xs={24}>
                    <ParagraphHeader header="My Initiatives" />
                    <RenderAnonymous >
                        <div className="nys-info-bar my-initiatives-page">
                            <p>
                                <span>
                                    Please Note:
                                </span>
                                You are not logged in. Please log in to access the SEIMS Initiatives that you are subscribed to.
                            </p>
                        </div>
                    </RenderAnonymous>
                    <Row style={{ justifyContent: "center" }} gutter={[16, 16]} className="card-section">
                        {subscribedInitiatives?.map((item, index) => (
                            <Col key={"Programme-" + index} className="my-initiatives" xs={{ span: 24 }} sm={{ span: 12 }} md={8} lg={6}>
                                <ProgrammeCard programme={item} />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
            {/* <Divider /> */}
            <Row style={{ paddingBottom: 30, paddingTop: 20 }} className="page-header">
                <Col xs={24}>
                    <ParagraphHeader header="Other Initiatives" />
                    <Row gutter={[16, 16]} style={{ justifyContent: "center" }} className="card-section">
                        {unSubscribedInitiatives?.map((item, index) => (
                            <Col key={"Programme-" + index} className="my-initiatives" xs={{ span: 24 }} sm={{ span: 12 }} md={8} lg={6}>
                                <ProgrammeCard programme={item} />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    )
}
